import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Link, browserHistory } from 'react-router';
import _ from 'lodash';

// components
import FeatureFlags from '../../../util/featureFlags';
import ThemeSwatches from './ThemeSwatches';
import WebsiteNav from '../../common/header/SecondaryNav/SecondaryNav';
import SelectAndCustomizeButton from '../common/SelectAndCustomizeButton';
import ConnectedRelatedCardsCarousel from '../../../cards/components/common/RelatedCardsCarousel/RelatedCardsCarousel';

// actions
import { getByKeyV2, resetThemes, storeCurrentThemeKey } from '../../../actions/website/ThemeActions';
import { updateWeddingTheme, fetchWeddingAccount, disableWebsiteOnboarding } from '../../../actions/WeddingActions';
import { showModal } from '../../../actions/ModalActions';

// import MatchingCardCarousel from '../../common/MatchingCardCarousel/MatchingCardCarousel';
import { weddingWebsiteNavItems, manageNavItems } from '../../common/header/SecondaryNav/secondaryNavData';
import { trackOnboardingCompleted } from '../../../util/trackingHelper';

// css & assets
import '../../../stylesheets/pages/components/ThemeDetail.less';
import ChromeBar from '../../../assets/images/icons/icon-chrome.svg';
import { getUserWeddingDate } from '../../../selectors/user/userSelectors';

class ThemeDetail extends Component {
  constructor(props) {
    super(props);
    this.state = {
      themeGroup: props.themeGroup,
      currentTheme: props.currentTheme,
      activeDotIdx: 0,
      currentThemeFamily: '',
      relatedCardsCarouselStatus: true,
      choseNewTheme: false,
    };
    this.changeThemeView = this.changeThemeView.bind(this);
    this.generateMarketingModule = this.generateMarketingModule.bind(this);
    this.flipCarouselToMarketingModule = this.flipCarouselToMarketingModule.bind(this);
    this.handleSelect = this.handleSelect.bind(this);
  }

  componentDidMount() {
    const { loadTheme } = this.props;
    loadTheme();
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.currentTheme) {
      this.setState({
        currentTheme: nextProps.currentTheme
      });
    } else if ((nextProps.themeGroup && nextProps.themeGroup.themes) && !this.state.currentTheme) {
      this.setState({
        currentTheme: nextProps.themeGroup.themes[0]
      });
    }
  }

  componentWillUnmount() {
    const { unloadTheme, storeThemeKey, currentTheme } = this.props;
    if (currentTheme) {
      const themeKey = currentTheme.key;
      storeThemeKey(themeKey);
    }
    unloadTheme();
  }

  changeThemeView(theme) {
    this.setState({
      currentTheme: theme
    });
  }

  generateMarketingModule() {
    return (
      <Link to="/wedding-planning/save-the-date/shop">
        <div className="marketing-module" />
      </Link>
    );
  }

  flipCarouselToMarketingModule() {
    this.setState({
      relatedCardsCarouselStatus: null
    });
  }

  handleSelect(themeId, onboard) {
    const { setWeddingTheme, weddingDate } = this.props;

    this.setState({
      choseNewTheme: true,
    });

    setWeddingTheme(themeId, onboard, weddingDate);
  }

  render() {
    const { themeGroup, slug, pageKey, shareInfo, weddingTheme, onboard, searchFilterColor } = this.props;
    const { currentTheme, relatedCardsCarouselStatus, choseNewTheme } = this.state;
    return (
      <div>
        <div>
          {
            window.zola.feature.newUnifiedNav
              ? <span className="visible-md-block visible-lg-block"><WebsiteNav slug={slug} pageKey={pageKey} shareInfo={shareInfo} navItems={weddingWebsiteNavItems} altActive /></span>
              : <span className="visible-md-block visible-lg-block"><WebsiteNav slug={slug} pageKey={pageKey} shareInfo={shareInfo} navItems={manageNavItems} altActive /></span>
          }
          <span className="hidden-md hidden-lg"><WebsiteNav slug={slug} pageKey={pageKey} shareInfo={shareInfo} navItems={weddingWebsiteNavItems} altActive /></span>
        </div>
        <div>
          <div id="themes-nav-wrapper">
            <div className="content-top">
              <div>
                <div className="nav navbar-nav navbar-left">
                  <Link to="/wedding/manage/website/designs" className="themes-detail-back"><i className="zolaicon zolaicon-chevron-left" /> Back To All Designs</Link>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="container-fluid theme-details theme-detail-postauth-v2 theme-detail-postauth">
          {currentTheme && (
            <div className="row">
              <div className="col-xs-12 visible-xs">
                <div className="theme-wrapper">
                  {currentTheme.id === weddingTheme.id && (
                    <span className="zolaicon-checkmark theme-title_selected-icon" />
                  )}
                  <h3 className="theme-title">{themeGroup.title} {themeGroup.is_new && <div className="zola-ui tag tag--sm tag--primary">NEW</div>}</h3>
                </div>
                {themeGroup.partner_name && (
                  <p className="theme-detail-designedby">Designed by {themeGroup.partner_url ? <a href={themeGroup.partner_url}>{themeGroup.partner_name}</a> : <span>{themeGroup.partner_name}</span>}</p>
                )}
                <a href={`/wedding/sample-${currentTheme.key}`} target="_blank" rel="noopener noreferrer" className="text-button theme-demo-action"><span className="text-button__icon zolaicon zolaicon-visible" />See A Demo</a>
                <p className="theme-detail-description">{themeGroup.description}</p>
                <h5 className="text-sans theme-swatch-heading">COLOR</h5>
                <div className="swatches-partner-container">
                  <ThemeSwatches themeOptions={themeGroup} onSwatchClick={this.changeThemeView} currentTheme={currentTheme} pageName="theme-detail" />
                  {themeGroup.partner_cta_label && (
                    <p>
                      {themeGroup.partner_cta_label} {themeGroup.partner_cta_url ? <a href={themeGroup.partner_cta_url}>{themeGroup.partner_name}</a> : <span>{themeGroup.partner_name}</span>}
                    </p>
                  )}
                </div>
                {themeGroup.partner_cta_label && (
                  <p>{themeGroup.partner_cta_label} {themeGroup.partner_cta_url ? <a href={themeGroup.partner_cta_url}>{themeGroup.partner_name}</a> : <span>{themeGroup.partner_name}</span>}</p>
                )}
                <div className="actions">
                  <SelectAndCustomizeButton currentTheme={currentTheme} weddingTheme={weddingTheme} clickHandler={this.handleSelect} onboard={onboard} choseNewTheme={choseNewTheme} />
                </div>
                {FeatureFlags.get('websitesPDPCarousel') && currentTheme && themeGroup && themeGroup.title && relatedCardsCarouselStatus && (
                  <div className="related-cards-carousel">
                    <div className="related-cards-carousel__section hidden-lg hidden-md">
                      <ConnectedRelatedCardsCarousel
                        family={themeGroup.title}
                        filterColor={searchFilterColor[0]}
                        initialVariationColor={currentTheme.swatch_color_1}
                        referenceType="website"
                        lightView
                        fallbackDisplay={this.flipCarouselToMarketingModule}
                      />
                    </div>
                  </div>
                )}
                {FeatureFlags.get('websitesPDPCarousel') && _.isNull(relatedCardsCarouselStatus) && this.generateMarketingModule()}
                {!FeatureFlags.get('websitesPDPCarousel') && this.generateMarketingModule()}
              </div>
              <div className="col-sm-7 col-sm-triple-gutter-left col-xs-12 theme-preview-container">
                {
                  window.zola.env !== 'production' && <img src={ChromeBar} alt="icon chrome" className="img-responsive center-block icon-chrome" />
                }
                <div className="big-preview">
                  <img src={currentTheme.full_preview_image} alt={themeGroup.name} className="img-responsive center-block" />
                </div>
              </div>
              <div className="col-sm-5 col-sm-triple-gutter-right hidden-xs">
                <h3 className="theme-title-v2">
                  {currentTheme.id === weddingTheme.id && (
                    <span className="zolaicon-checkmark theme-title_selected-icon" />
                  )}
                  {themeGroup.title} {themeGroup.is_new && <div className="zola-ui tag tag--sm tag--primary">NEW</div>}
                </h3>
                {themeGroup.partner_name && (
                  <p className="theme-detail-designedby">Designed by {themeGroup.partner_url ? <a href={themeGroup.partner_url} target="_blank" rel="noopener noreferrer">{themeGroup.partner_name}</a> : <span>{themeGroup.partner_name}</span>}</p>
                )}
                <a href={`/wedding/sample-${currentTheme.key}`} target="_blank" rel="noopener noreferrer" className="text-button theme-demo-action"><span className="text-button__icon zolaicon zolaicon-visible" />See A Demo</a>
                <p className="theme-detail-description">{themeGroup.description}</p>
                {themeGroup.partner_cta_label && (
                  <p>{themeGroup.partner_cta_label} {themeGroup.partner_cta_url ? <a href={themeGroup.partner_cta_url} target="_blank" rel="noopener noreferrer">{themeGroup.partner_name}</a> : <span>{themeGroup.partner_name}</span>}</p>
                )}
                <div className="">
                  <div className="color__wrapper">
                    <h5 className="text-sans theme-swatch-heading">COLOR</h5>
                    <div className="swatches-partner-container">
                      <ThemeSwatches themeOptions={themeGroup} onSwatchClick={this.changeThemeView} currentTheme={currentTheme} pageName="theme-detail" />
                      {themeGroup.partner_cta_label && (
                        <p>{themeGroup.partner_cta_label} {themeGroup.partner_cta_url ? <a href={themeGroup.partner_cta_url}>{themeGroup.partner_name}</a> : <span>{themeGroup.partner_name}</span>}</p>
                      )}
                    </div>
                  </div>
                  <div className="actions__wrapper">
                    <div className="actions">
                      <SelectAndCustomizeButton currentTheme={currentTheme} weddingTheme={weddingTheme} clickHandler={this.handleSelect} onboard={onboard} choseNewTheme={choseNewTheme} />
                    </div>
                  </div>
                </div>
                {FeatureFlags.get('websitesPDPCarousel') && currentTheme && themeGroup && themeGroup.title && relatedCardsCarouselStatus && (
                  <div className="related-cards-carousel">
                    <div className="related-cards-carousel__section hidden-xs">
                      <ConnectedRelatedCardsCarousel
                        family={themeGroup.title}
                        filterColor={searchFilterColor[0]}
                        initialVariationColor={currentTheme.swatch_color_1}
                        referenceType="website"
                        lightView
                        fallbackDisplay={this.flipCarouselToMarketingModule}
                      />
                    </div>
                  </div>
                )}
                {FeatureFlags.get('websitesPDPCarousel') && _.isNull(relatedCardsCarouselStatus) && this.generateMarketingModule()}
                {!FeatureFlags.get('websitesPDPCarousel') && this.generateMarketingModule()}
              </div>
            </div>
          )}
        </div>
      </div>
    );
  }
}

ThemeDetail.propTypes = {
  themeGroup: PropTypes.shape({
    themes: PropTypes.arrayOf(
      PropTypes.shape({})
    ),
    currentTheme: PropTypes.shape({}),
    title: PropTypes.string,
  }),
  currentTheme: PropTypes.shape({
    theme: PropTypes.shape({}),
  }),
  weddingTheme: PropTypes.shape({}),
  loadTheme: PropTypes.func.isRequired,
  unloadTheme: PropTypes.func.isRequired,
  setWeddingTheme: PropTypes.func.isRequired,
  onboard: PropTypes.bool,
  storeThemeKey: PropTypes.func,
  slug: PropTypes.string,
  shareInfo: PropTypes.shape({}),
  pageKey: PropTypes.string,
  searchFilterColor: PropTypes.arrayOf(PropTypes.string),
};

const mapStateToProps = state => ({
  themeGroup: state.website.themeListing.themeDetails,
  weddingTheme: state.wedding.theme,
  onboard: !state.wedding.account.disable_website_onboarding,
  currentTheme: state.website.themeListing.currentTheme.theme,
  busy: state.website.themeListing.busy,
  slug: state.wedding.wedding.slug,
  shareInfo: Object.assign({}, _.pick(state.wedding.account, 'enable_passcode', 'passcode')),
  published: state.wedding.account.published,
  searchFilterColor: state.website.themeListing.selected_color_keys,
  weddingDate: getUserWeddingDate(state)
});

const mapDispatchToProps = (dispatch, ownProps) => ({
  loadTheme: () => {
    dispatch(getByKeyV2(ownProps.params.themeKey));
  },
  unloadTheme: () => dispatch(resetThemes()),
  setWeddingTheme: (themeId, onboard, weddingDate) => {
    dispatch(updateWeddingTheme(themeId));
    if (onboard) {
      dispatch(fetchWeddingAccount()).then(() => {
        dispatch(disableWebsiteOnboarding());
        trackOnboardingCompleted('WEDDINGS', 'WEDDING_WEBSITE', { isExistingUser: true, weddingDate });
        browserHistory.push('/wedding/manage/website/pages/home');
      });
    } else {
      browserHistory.push('/wedding/manage/website/pages/home');
    }
  },
  storeThemeKey: themeKey => dispatch(storeCurrentThemeKey(themeKey)),
  openShare: (wedding) => {
    dispatch(showModal('SHARE', { wedding }, { size: 'md' }));
  },
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ThemeDetail);



// WEBPACK FOOTER //
// ./src/components/manage/website/ThemeDetail.jsx